let wf = require('waterfall')
let HiFs = require('hifs')
let HiAlive = require('hialive')


function trimBasePath(base) {
    let prefix = "https://localhost/"
    if (base.indexOf(prefix) !== -1) {
        return base.substr(base.indexOf(prefix) + prefix.length)
    }

    prefix = "http://localhost/"
    if (base.indexOf(prefix) !== -1) {
        return base.substr(base.indexOf(prefix) + prefix.length)
    }

    prefix = "//localhost/"
    if (base.indexOf(prefix) !== -1) {
        return base.substr(base.indexOf(prefix) + prefix.length)
    }
    
    return base
}


let wfClient = new wf.ApiClient()
console.log("wfClient.basePath:", wfClient.basePath)
wfClient.basePath = trimBasePath(wfClient.basePath)
console.log("wfClient.basePath:", wfClient.basePath)
wfClient.defaultHeaders = {}

let conf = new wf.ConfApi(wfClient)
let sess = new wf.SessionApi(wfClient)
let key = new wf.KeyApi(wfClient)
let shell = new wf.ShellApi(wfClient)
let ssh = new wf.SshApi(wfClient)
let ver = new wf.VerApi(wfClient)


let hifsClient = new HiFs.ApiClient()
console.log("hifsClient.basePath:", hifsClient.basePath)
hifsClient.basePath =  trimBasePath(hifsClient.basePath)
console.log("hifsClient.basePath:", hifsClient.basePath)
hifsClient.defaultHeaders = {} // Disable generated unsafe User-Agent when generated js client code on Mac OS
let hifs = new HiFs.HifsApi(hifsClient)

let hialiveClient = new HiAlive.ApiClient()
console.log("hialiveClient.basePath:", hialiveClient.basePath)
hialiveClient.basePath = trimBasePath(hialiveClient.basePath)
console.log("hialiveClient.basePath:", hialiveClient.basePath)
hialiveClient.defaultHeaders = {}
let report = new HiAlive.ReportApi(hialiveClient)

function errHandler(vm, error, response) {
    if (error) {
        // vm.$notify.error(`${response.statusCode}: ${response.text}`)
        // console.log("api errHandler error:", error)
        // console.log("api errHandler response:", response)
        vm.$notify.error({
            title: response.statusCode,
            message: response.text,
            duration: 0
        })
    }
}

function delFile(vm, path) {
    hifs.deleteFile(path, (error, data, response) => {
        if (error) {
            console.error(error);
            errHandler(vm, error, response)
        }
    });
}

function postNewSession(vm, sess, sessFilePath, existCallback, successCallback) {
    // 检查会话文件是否已存在
    hifs.getPath(sessFilePath, (error, data, response) => {
        if (error) {
            errHandler(vm, error, response)
        } else {
            // 会话文件已存在
            if (data == true) {
                console.log("postNewSession: data", data)
                existCallback(vm)
                return
            }

            // 会话文件不存在, 直接提交新文件
            postSession(vm, sess, sessFilePath, successCallback)
        }
    })
}

// 推送 session 到服务器
function postSession(vm, session, sessFilePath, successCallback) {
    vm.posting = true

    // 先加密密码
    let opts = {
        'password': session.Password // String | 密码
    };
    sess.getSessionPasswordEncrypted(opts, (error, data, response) => {
        if (error) {
            errHandler(vm, error, response)
        } else {
            // 获取加密后的密码成功
            session.Password = data

            // 发送 session 到服务端
            let blob = new Blob([JSON.stringify(session)])
            hifs.postFile(sessFilePath, blob, (error, data, response) => {
                vm.posting = false
                if (error) {
                    errHandler(vm, error, response)
                } else {
                    successCallback()
                }
            })
        }
    });
}

export default {
    conf,
    hifs,
    sess,
    key,
    shell,
    ssh,
    ver,
    errHandler,

    postSession,
    postNewSession,

    delFile,

    report,
}
